import { Handle, Position, type NodeProps, type Node } from '@xyflow/react';
import clsx from 'clsx';

interface FlowGroupNodeData extends Record<string, unknown> {
  label: string;
  width?: number;
  height?: number;
}

type FlowGroupNode = Node<FlowGroupNodeData>;

export const FlowGroupNode = ({ data, selected }: NodeProps<FlowGroupNode>) => {
  return (
    <>
      <Handle type='target' position={Position.Left} className='w-4 h-4 bg-blue-400 border-2 border-white' />

      <div
        className={clsx(
          'bg-slate-50 border-2 rounded-xl p-4',
          'transition-all duration-200',
          selected ? 'border-slate-400' : 'border-slate-300'
        )}
        style={{
          width: data?.width,
          height: data?.height
        }}
      >
        {/* Header */}
        <div className='flex items-center gap-2'>
          <div className='flex flex-col gap-1'>
            <div className='flex items-center gap-2'>
              <span className='px-2 py-1 rounded text-xs font-medium bg-fuchsia-200 text-fuchsia-800'>
                Contact Flow
              </span>
            </div>
            <div className='text-neutral-950 font-semibold text-md leading-tight'>{data?.label}</div>
          </div>
        </div>
      </div>

      <Handle type='source' position={Position.Right} className='w-4 h-4 bg-blue-400 border-2 border-white' />
    </>
  );
};
